import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Field, Select, Table } from '@itds/elements/index.js';

import EditAgencyRoleDrawer from './EditAgencyRole';

import Api from '@brokerage/utils/Api';

const Agencies = ({ agencies, member }) => {
  const [default_agency_id, setDefaultAgencyId] = useState(member.default_agency_id);
  const [role, setRole] = useState(null);

  const handleDefaultAgencyChange = e => {
    setDefaultAgencyId(e.target.value);

    Api.updateMember(member.id, { default_agency_id: e.target.value }).then(() => {
      // success silently
    });
  };

  const removeFromAgency = (role, e) => {
    e.stopPropagation();

    Api.deleteMemberAgencyRole(role.id).then(() => {
      window.location.reload();
    });
  };

  const handleSave = () => {
    setRole(null);
    window.location.reload();
  };

  return (
    <div>
      <EditAgencyRoleDrawer
        agencies={agencies.filter(a => !member.agencies.find(agency => agency.id === a.id))}
        member={member}
        onClose={setRole.bind(null, null)}
        onSave={handleSave}
        role={role}
        show={!!role}
      />

      <div style={{ display: 'flex' }}>
        <Field label='Default Agency' style={{ width: 400 }}>
          <Select
            onChange={handleDefaultAgencyChange}
            options={[{ value: '', label: '-- No Default Agency --' }].concat(
              member.agencies.map(a => ({ value: a.id, label: a.name }))
            )}
            value={default_agency_id}
          />
        </Field>

        <Button onClick={setRole.bind(null, {})} style={{ marginLeft: 'auto', marginTop: 26 }}>
          Add To Agency
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Role'
          },
          {
            id: 'agency',
            label: 'Agency',
            render: role => member.agencies.find(a => a.id === role.agency_id).name
          },
          {
            id: 'permissions',
            label: 'Permissions',
            render: role => role.permissions.join(', ')
          },
          {
            id: 'actions',
            label: '',
            styles: { textAlign: 'right', width: 170 },
            render: role => {
              return (
                <Button color='RED' onClick={removeFromAgency.bind(null, role)} small={true}>
                  Remove From Agency
                </Button>
              );
            }
          }
        ]}
        data={member.member_agency_roles}
        onRowClick={setRole}
      />
    </div>
  );
};

Agencies.propTypes = {
  agencies: PropTypes.array,
  member: PropTypes.object
};

export default Agencies;
